var map = {
	"./e-and": [
		1291,
		291
	],
	"./e-and copy": [
		8440,
		440
	],
	"./e-and copy.json": [
		8440,
		440
	],
	"./e-and.json": [
		1291,
		291
	],
	"./hsbc-stablecoin": [
		4575,
		575
	],
	"./hsbc-stablecoin.json": [
		4575,
		575
	],
	"./strategic-positioning": [
		7358,
		358
	],
	"./strategic-positioning.json": [
		7358,
		358
	],
	"./uk-expansion": [
		9232,
		232
	],
	"./uk-expansion.json": [
		9232,
		232
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7957;
module.exports = webpackAsyncContext;